export class FeatureToggle {
  enableAi = false;
  enableBarcode = false;
  enableProntuary = false;
  enableReport = false;
  enableDiscussion = false;
  enableRegisterCase = false;
  enableImageDatabase = false;
  enableKi67 = false;
  viewerUrlExternal = '';
}
